<template>
  <div class="dropdown-container">
    <DropdownPrime 
      v-model="selectedValue" 
      :options="options" 
      optionLabel="label" 
      optionValue="value" 
      placeholder="Sexo" 
      :class="{'p-invalid': mostrarErrores && error}" 
      v-bind:[tooltipDirective]="tooltip" 
      @change="emitSelection"
    />
    <small v-if="mostrarErrores && error" class="p-error">{{ error }}</small>
  </div>
</template>

<script>
import { ref } from 'vue';

export default {
  props: {
    mostrarErrores: {
      type: Boolean,
      default: false
    },
    tooltip: {
      type: String,
      default: ''
    },
    error: {
      type: String,
      default: ''
    },
    modelValue: {
      type: String,
      default: ''
    }
  },
  setup(props, { emit }) {
    const options = ref([
      { label: 'Femenino', value: 'F' },
      { label: 'Masculino', value: 'M' },
      { label: 'Otro', value: 'O' }
    ]);
    const selectedValue = ref(props.modelValue);

    const emitSelection = () => {
      emit('update:modelValue', selectedValue.value);
    };

    return {
      options,
      selectedValue,
      emitSelection
    };
  }
}
</script>

<style scoped>
.dropdown-container {
  margin-bottom: 1rem;
}
</style>